module.exports = __webpack_public_path__ + "img/pointBanner.ddc1526f.png";